import React from "react"
//import BackgroundImage from "gatsby-background-image"
import { Link } from "gatsby"
import { BsArrowRight } from "react-icons/bs"
import Img from "gatsby-image"

const HeroSection = ({ img }) => {
  return (
    <section className="min-h-screen bg-dark">
      <div className="max-w-screen-md xl:max-w-screen-lg mx-auto">
        {/*XL above 1024px */}
        <div className="hidden xl:grid grid-cols-1 xl:grid-cols-2 min-h-screen gap-5 bg-dark">
          <div className="flex flex-col justify-center">
            <div className="iam-text lg:text-2xl text-lg pb-6 pt-4 leading-none">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-gray-600 via-white to-gray-600">
                HI, I'M ABHISHEK GAUTAM
              </span>
            </div>

            <p className="text-white font-metropolis font-medium lg:text-5xl text-4xl tracking-tight leading-tight pb-20">
              I help early startups and local businesses in building their
              online presence.
            </p>

            <div className="flex space-x-10 md:space-x-8">
              <Link
                to="https://calendly.com/abhishekgautam/freelance-work"
                target="_blank"
              >
                <button
                  className=" text-white border border-white py-3 px-10 font-metropolis font-normal text-base lg:py-4 lg:px-10 hover:bg-yellow-500 hover:border-yellow-500 hover:text-black focus:outline-none transition-all duration-300 ease-linear tracking-wide"
                  aria-label="Book a free call"
                >
                  BOOK A FREE CALL
                </button>
              </Link>
              <Link to="/projects" aria-label="View projects">
                <button className="w-auto h-full font-metropolis font-medium text-base tracking-wide lg:px-6 lg:py-5 text-white focus:outline-none transition-all duration-300 ease-linear">
                  <div className="flex items-center justify-center">
                    <span className="bg-clip-text text-transparent bg-gradient-to-r from-gray-600 to-white">
                      VIEW PROJECTS
                    </span>
                    <span className="pl-4">
                      <BsArrowRight className="text-white text-xl" />
                    </span>
                  </div>
                </button>
              </Link>
            </div>
          </div>
          <div className="flex flex-col items-center justify-center">
            <Img fluid={img} alt="" className="w-full" />
          </div>
        </div>
        {/*Mobile and Tablet upto 1024px */}
        <div className="xl:hidden grid grid-cols-1 xl:grid-cols-2 min-h-screen pt-10  bg-dark sm:pt-20 md:pt-12 ">
          <div className="flex flex-col items-center justify-center">
            <Img fluid={img} alt="" className="w-5/6 md:w-3/5 lg:w-9/12" />
          </div>
          <div className="flex flex-col justify-center pt-4 sm:pt-0">
            <div className="font-metropolis font-semibold lg:text-2xl text-base sm:text-lg md:text-xl pb-6 leading-none tracking-tight px-10 sm:px-24 lg:px-0">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-gray-600 via-white to-gray-600">
                HI, I'M ABHISHEK GAUTAM
              </span>
            </div>

            <p className=" text-white lg:text-5xl font-metropolis font-medium text-2xl sm:text-3xl tracking-tight leading-tight pb-12 sm:pb-16 px-10 sm:px-24 lg:px-0">
              I help early startups and local businesses in building their
              online presence.
            </p>

            <div className="sm:flex space space-x-10 md:space-x-12 px-10 sm:px-24 mb-10">
              <Link to="https://calendly.com/abhishekgautam/freelance-work">
                <button
                  className="w-full sm:w-auto text-white border border-white font-metropolis font-normal py-3 px-5 text-sm lg:py-3 lg:px-6 hover:bg-yellow-500 hover:border-yellow-500 hover:text-black focus:outline-none transition-all duration-300 ease-linear mb-5 sm:mb-0"
                  aria-label="View Our Menu"
                >
                  BOOK A FREE CALL
                </button>
              </Link>
              <Link to="/projects">
                <div
                  className="flex items-center font-metropolis font-medium justify-center w-full sm:w-auto py-3 px-5 text-sm md:text-base tracking-wide mt-5 md:mt-0 lg:py-3 lg:px-6 text-white focus:outline-none transition-all duration-300 ease-linear"
                  aria-label="More About Us"
                >
                  <span className="bg-clip-text text-transparent bg-gradient-to-r from-gray-600 to-white">
                    VIEW PROJECTS
                  </span>
                  <div className="pl-4">
                    <BsArrowRight className="text-white text-xl" />
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HeroSection
